import { CHANNELS, CRON_SPECIAL, DEFAULT_CRON, FREQUENCIES, GENERATORS, OUTPUT_FORMATS } from './constants'
import { sectionToSelectOption, userToSelectOption } from './buildFormOptions'

export const INSTANT_GENERATORS = [GENERATORS.SECTION, GENERATORS.RESOURCE]
const SFTP_GENERATORS = [GENERATORS.COLLECT, GENERATORS.RESOURCE]
const SFTP_PDF_GENERATORS = [GENERATORS.ALERT, GENERATORS.SECTION, GENERATORS.RESOURCE]
const EMAIL_GENERATORS = [GENERATORS.SECTION, GENERATORS.ALERT, GENERATORS.OPERATOR, GENERATORS.RESOURCE]
const SCROLL_DELAY_MS = 100
const BLANK_ERROR = ['doit être rempli(e)']

export const allowedGeneratorsFor = (channel, outputFormat) => {
  if (channel !== CHANNELS.SFTP)
    return EMAIL_GENERATORS
  return outputFormat === OUTPUT_FORMATS.PDF ? SFTP_PDF_GENERATORS : SFTP_GENERATORS
}

export const scrollToFirstError = () => {
  setTimeout(() => {
    const firstInvalidField = document.querySelector('.is-invalid')
    if (!firstInvalidField)
      return
    firstInvalidField.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }, SCROLL_DELAY_MS)
}

export const DEFAULT_FORM_DATA = {
  name: '',
  generator: GENERATORS.ALERT,
  cronExpression: DEFAULT_CRON,
  channel: CHANNELS.EMAIL,
  outputFormat: OUTPUT_FORMATS.XLSX,
  userIds: [],
  sectionIds: [],
  variableId: null,
  credentialId: null,
  priorityResources: false,
  currentDraftOnly: false,
  exportAll: false,
  useExternalEmails: false,
  summaryFilters: []
}

export const buildFormDataFromSummary = summary => ({
  name: summary.name,
  generator: summary.generator,
  cronExpression: summary.cron_expression || CRON_SPECIAL.INSTANT,
  channel: summary.channel,
  outputFormat: summary.output_format,
  userIds: (summary.users || []).map(userToSelectOption),
  sectionIds: (summary.sections || []).map(sectionToSelectOption),
  variableId: summary.variable_id,
  credentialId: summary.credential_id,
  priorityResources: summary.priority_resources,
  currentDraftOnly: summary.current_draft_only,
  exportAll: summary.export_all,
  useExternalEmails: Boolean(summary.variable_id),
  summaryFilters: (summary.summary_filters || []).map(filter => ({
    id: filter.id,
    variableId: filter.variable_id,
    values: filter.values || [],
    destroy: false
  }))
})

export const supportsExportAll = (formData, collectFrequency) => formData.generator === GENERATORS.RESOURCE
  && collectFrequency === FREQUENCIES.SPONTANEOUS
  && formData.cronExpression !== CRON_SPECIAL.INSTANT

export const supportsExternalEmails = formData => formData.cronExpression === CRON_SPECIAL.INSTANT
  && INSTANT_GENERATORS.includes(formData.generator)
  && formData.channel !== CHANNELS.SFTP

export const validateFormData = formData => {
  const errors = {}
  if (formData.useExternalEmails && !formData.variableId)
    errors.variable = BLANK_ERROR
  if (formData.channel === CHANNELS.SFTP && !formData.credentialId)
    errors.credential = BLANK_ERROR
  if (formData.generator === GENERATORS.SECTION && formData.sectionIds.length === 0)
    errors.sections = BLANK_ERROR
  return errors
}

/* eslint-disable camelcase */
export const buildPayload = (formData, filtersAttributes) => ({
  name: formData.name,
  generator: formData.generator,
  cron_expression: formData.cronExpression === CRON_SPECIAL.INSTANT ? '' : formData.cronExpression,
  channel: formData.channel,
  output_format: formData.outputFormat,
  user_ids: formData.userIds.map(option => option.value),
  section_ids: formData.sectionIds.map(option => option.value),
  variable_id: formData.useExternalEmails ? formData.variableId : null,
  credential_id: formData.credentialId,
  priority_resources: formData.priorityResources,
  current_draft_only: formData.currentDraftOnly,
  export_all: formData.exportAll,
  summary_filters_attributes: filtersAttributes || []
})
/* eslint-enable camelcase */
